export const OPEN = "OPEN"
export const DUE = "DUE"
export const NEXT = "NEXT"
export const CLOSED = "CLOSED"
export const DUPLICATE = "DUPLICATE"
export const BILLET = "BILLET"
export const PIX = "PIX"
export const BAR_CODE = "BAR_CODE"
export const INVOICE_DOWNLOAD = "INVOICE_DOWNLOAD"
export const ACCOUNT_DETAILS = "ACCOUNT_DETAILS"
export const FEBRABAN_ACCOUNT = "FEBRABAN_ACCOUNT"
export const EMAIL = "EMAIL"
export const INVOICE_DISPUTING = "INVOICE_DISPUTING"
export const PDF = "PDF"
export const EXCEL = "EXCEL"
export const DETAILS = "SIM"
export const SIN = "SIN"
export const SIEBEL = "SIEBEL"
export const ODIN = "ODIN"
export const KENAN = "KENAN"
export const ACTIVE = "ACTIVE"
export const NONE = "NONE"
export const WHATSAPP_API_URL = "https://api.whatsapp.com/send?phone="
export const CORP_WHATSAPP = "5534998892822&text=Falar%20com%20atendente"
export const CORP_WHATSAPP_PAYMENT_QUESTION =
  "5534998892822&text=Estou%20com%20d%C3%BAvida%20sobre%20os%20m%C3%A9todos%20de%20pagamento"

export const POSITIVE = ["ACTIVE", "ATIVO", "SIM", "S"]
export const NEGATIVE = ["INACTIVE", "INATIVO", "NAO", "N"]

export const PRODUCT_SYSTEMS = {
  VANTIVE: "VANTIVE",
  ALGAR_CRM: "ALGAR CRM",
  SIEBEL,
  SIN,
  ODIN: "ODIN"
}

export const ENABLED_INCIDENT_PRODUCT_SYSTEMS = [
  PRODUCT_SYSTEMS.VANTIVE,
  PRODUCT_SYSTEMS.ALGAR_CRM,
  PRODUCT_SYSTEMS.SIEBEL,
  PRODUCT_SYSTEMS.ODIN
]

export const ProductStatusTranslations = {
  ACTIVE: "MSG_0050",
  ATIVO: "MSG_0050",
  BLOCKED: "MSG_0143",
  BLOQUEADO: "MSG_0143",
  CHARGE_BLOCKED: "MSG_0401",
  BLOQUEIO_COBRANÇA: "MSG_0401",
  INACTIVE: "MSG_0059",
  INATIVO: "MSG_0059",
  SUSPENDED: "MSG_0145",
  WAITING_INSTALLATION: "MSG_0146",
  NOT_SUPPORTED: "MSG_0147",
  FINISHED: "FINISHED"
}

export const ProductsPlantFilter = {
  productName: "MSG_0051",
  status: "MSG_0052",
  circuit: "MSG_0100"
}

export const PRODUCTSTATUS = {
  ATIVO: "ACTIVE",
  BLOQUEADO: "BLOCKED",
  INATIVO: "INACTIVE",
  SUSPENSO: "SUSPENDED",
  "AGUARDANDO INSTALACAO": "WAITING_INSTALLATION",
  TERMINADO: "FINISHED",
  "BLOQUEIO COBRANÇA": "CHARGE_BLOCKED",
  NOT_SUPPORTED: "NOT_SUPPORTED"
}

export const ProductsTNCM = [
  "voz total",
  "internet link",
  "ip transito",
  "lan to lan",
  "wavelength node",
  "vpn",
  "dark fiber",
  "clear channel",
  "voz fixa",
  "voip",
  "cloud phone",
  "sd-wan"
]

export const ProductsValidMpe = [
  "internet link",
  "lan to lan node",
  "vpn node",
  "ip transito",
  "wavelength node",
  "voz total",
  "dark fiber"
]

export const ADVANCED_PRODUCT = [
  "INTERNET LINK",
  "VPN",
  "IP TRANSITO",
  "LAN TO LAN",
  "WAVELENGTH",
  "DARK FIBER",
  "CLOUD PHONE",
  "SD-WAN"
]

export const BLACKLIST = [
  "CLEAR CHANNEL",
  "GERENCIADOR",
  "OMNI PRO",
  "MICROSOFT",
  "COLOCATION",
  "HOSTING",
  "AZURE",
  "SMS SOLUTION",
  "ANTIVIRUS",
  "SIEM",
  "ENDPOINT",
  "GERENCIADO",
  "ANTI DDOS",
  "SMARTFI PRO",
  "SMART CONNECT",
  "TELEMETRIA",
  "MULTI CONNECT",
  "CONNECT ONE",
  "ISCA",
  "LORAWAN",
  "REDE PRIVATIVA",
  "AGRO",
  "DATALAKE",
  "FAST SUPPORT",
  "SERVICOS PROFISSIONAIS",
  "NEXT DEMAND",
  "NOC AS SERVICE",
  "ATENDIMENTO",
  "PREMIUM",
  "SOC VIP",
  "GERENCIAMENTO",
  "OFFICE",
  "TEAMS",
  "IOT",
  "PROJETO",
  "NETWORK"
]

export const blockM2M = "M2M"

export const blockIOT = "IOT"

export const ALIAS_CONSTANTS = {
  UPDATE: "update",
  DELETE: "delete",
  SUCESS_MESSAGE:
    "Cliente, o apelido atualizado com sucesso! Você pode alterar ou remover o apelido quando quiser.",
  ERROR_MESSAGE:
    "Cliente, não foi possivel realizar a atualização do apelido! Tente novamente mais tarde!"
}

export const UPDATE_DEBIT_AUTOMATIC = "UPDATE_DEBIT_AUTOMATIC"
export const ACTIVE_DEBIT_AUTOMATIC = "ACTIVE_DEBIT_AUTOMATIC"
export const INACTIVE_DEBIT_AUTOMATIC = "INACTIVE_DEBIT_AUTOMATIC"
export const PREPAGO = "PREPAGO"
export const POSPAGO = "POSPAGO"
export const TELEFONIA_MOVEL = "TELEFONIA MOVEL"
export const CONTROLE = "CONTROLE"
export const VOZ = "VOZ"
export const TELEFONIA_FIXA = "TELEFONIA FIXA"
export const BANDA_LARGA = "BANDA LARGA"
export const AVANCADOS = "AVANÇADOS"
export const COMUNICACAO_DADOS = "COMUNICACAO DADOS"
export const DATA_CENTER = "DATA CENTER"

export const VOIP = "VOIP"
export const SD_WAN = "SD-WAN"
export const BANDA_LARGA_KEYWORDS = ["banda larga"]

export const REPONSE_ERROR_ALREADY_OPEN = "os.already.open.noprotocol"
export const GENERIC_RESPONSE = "business.user.error"
export const LOCK_RESTRICTION_ERROR = "lock.restriction.iot.error"



// WEBPACK FOOTER //
// ./src/services/state/billing/constants.js